import styles from './GalleryView.module.scss'
import LazyLoader from '@/components/common/LazyLoader/LazyLoader'
import ProductCard from '@/components/common/ProductCard/ProductCard'
import ISearchResultSettings from '@/types/ISearchResultSettings'
import SearchMetaData from '@/types/SearchMetaData'
import { ArticleModel } from '@/types/api'
import React from 'react'

type Props = {
  items: any[],
  listId: string,
  listName: string,
  metaData?: SearchMetaData,
  settings?: ISearchResultSettings
  onSelect?: (item: ArticleModel) => void
}

const GalleryViewSearchResult = (props: Props) => {
  const getCompoent = (item: any) => {
    return (
      <ProductCard
        key={item.id}
        item={item}
        listId={props.listId}
        listName={props.listName}
        showSelectButton={props.settings?.showSelectButton}
        onSelect={props.onSelect}
        metaData={props.metaData}
      />
    )
  }

  return (
    <div className={styles.component}>
      <LazyLoader
        className={styles.productcards}
        items={props.items}
        itemsPerLoad={20}
        getComponent={getCompoent}
      />
    </div>
  )
}

export default GalleryViewSearchResult